let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZ3WI")).then(() => parcelRequire('immoC'));